import { render, staticRenderFns } from "./ExpartiateRemark.vue?vue&type=template&id=cf0af642&scoped=true"
import script from "./ExpartiateRemark.vue?vue&type=script&lang=js"
export * from "./ExpartiateRemark.vue?vue&type=script&lang=js"
import style0 from "./ExpartiateRemark.vue?vue&type=style&index=0&id=cf0af642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0af642",
  null
  
)

export default component.exports